"use client";
import React, { useCallback, useContext, useEffect, useState, useMemo } from "react";
import { Clock8, ChevronLeft, Radius } from "lucide-react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Button,
  Stack,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Collapse,
  IconButton,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import airlinelogo from "../../assets/images/active-flight-icon.svg";
//import { rateListSearch, clearRateList } from "@/redux/slice/rateavailability";
//import Loader from "@/common/Loader";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CategoryIcon from "@mui/icons-material/Category";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import { formatTemperatureRange } from "../common/BookingDetailUI";
import axios from "axios";
//import { setLFBooking } from "@/redux/slice/bookingSlice";
//import AlertDialogBox from "@/common/DialogBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import FlightIcon from "@mui/icons-material/Flight";
import AlertDialogBox from "../common/AlertDialogBox";
import {
  clearSearchRateAvailableData,
  searchratestate,
  setsearchratesAvailableData,
  viewBreakUp,
} from "../../store/SearchRates/SearchRatesSlice";
import { buildPassivePharmaDtl } from "../../utils/buildRateSearchPayload";
import { isKybApproved } from "../../utils/kyb";
import { kybstatus } from "../../store/User/KycSlice";
import BookCargo from "../common/PaymentSection/BookCargo";
import aeroplan from "../../assets/icons/aeroplan.png";
import pickup from "../../assets/icons/package-delivery.png";
import delivery from "../../assets/icons/delivery-charges.png";
import airfreight from "../../assets/icons/transportation.png";
import originimg from "../../assets/icons/origin.png";
import destinationimg from "../../assets/icons/destination.png";
import editquery from "../../assets/icons/edit_query.png";
import Bookingintermediatrypage from "../common/PaymentSection/BookingIntermediatrypage";
import { formatrates } from "../../functions/Utils";
import { setBookingdata } from "../../store/BookingIntermediaterypage/airlineairportslice";
import {
  getManualQuoteDetailById,
  setManualQuoteDetail,
} from "../../store/ManualQuote/ManualQuoteSlice";
import {
  updateStoredSearch,
  updatemanualsearch,
  updatequeryid,
  updatebookingid,
} from "../../store/Newsearchform/Newsearchform";
import { httpinstance } from "../../axios/api";
import { ManageSocketContext } from "../../ManageSocketContext";
import FailureSearchRate from "../../components/SearchRates/FailureSearchRate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { set } from "zod";
// import NoDataPage from "./../NoDataPage";
// import { use } from "react";
// import { insert } from "formik";
// Normalize backend airlineResponse into a date-grouped array
function normalizeAirlineResponse(airlineResponse) {
  if (!airlineResponse) return [];
  let rawItems = [];
  if (!Array.isArray(airlineResponse) && Array.isArray(airlineResponse.availabilityResponseSOs)) {
    rawItems = airlineResponse.availabilityResponseSOs;
  } else if (Array.isArray(airlineResponse)) {
    const isPreGrouped = airlineResponse.some((item) => item?.departureDate);
    if (isPreGrouped) {
      return airlineResponse.map((item) => ({
        ...item,
        departureDate:
          item.departureDate && item.departureDate !== "unknown"
            ? moment(item.departureDate).format("YYYY-MM-DD")
            : item.departureDate,
      }));
    }
    rawItems = airlineResponse;
  } else {
    return [];
  }
  const grouped = {};
  for (const so of rawItems) {
    const rawDepDate = so?.flightItineraries?.[0]?.scheduledDepartureDate || "unknown";
    const depDate =
      rawDepDate !== "unknown" ? moment(rawDepDate).format("YYYY-MM-DD") : "unknown";
    if (!grouped[depDate]) {
      grouped[depDate] = { departureDate: depDate, availabilityResponseSOs: [] };
    }
    grouped[depDate].availabilityResponseSOs.push(so);
  }
  return Object.values(grouped);
}

const NewRateAvailableList = (props, nodeData) => {
  //   // console.log(props?.nodeData?.requestType, "requestType");
  //    console.log("bookargo2");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const {

  //   routingPreference,
  //   commodityDetails,
  //   shipmentQuantityDetails,
  //   // productDetails,
  //   // searchquery,
  //   shipmentDimensions,
  // } = props.nodeData;
  const state = useSelector(updateStoredSearch);
  // const queryiddata=useSelector(updatequeryid);

  const { newsearchformdata, rqueryid } = state?.payload?.newsearchform;

  const {
    productDetails,
    searchquery,
    commodityId,
    commodity_description,
    specialHandlingCodes,
    requestType,
    apiCall,
    lowertempbound,
    temperatureRange,
    uppertempbound,
    airwaybillNumber,
    flightitinaries
  } = newsearchformdata;
  const { cargoType } = props?.nodeData
  const {
    destinationPort,
    originPort,
    goodsDetails,
    packagingDetails,
    paymentTerms,
    // cargoType,
  } = props?.nodeData?.searchquery;
  const { searchratesAvailableData } = useSelector(searchratestate);

  const [Qrbookingid, setQrbookingid] = useState();
  const [bookingId, setBookingId] = useState();
  const { receivingResponse, hasMore, setReceivingResponse, hasnodata, queryId } =
    useContext(ManageSocketContext);
  // console.log(hasnodata,"hasnodata")
  const [queryid, setqueryid] = useState(); // [queryid,]
  const [airres, setAirres] = useState(false);
  const [mergedAirlineResponse, setMergedAirlineResponse] = useState([]);

  const [waitforfrieghtos, setwaitforfrieghtos] = useState(false);
  const availabilityResponseSOs = mergedAirlineResponse?.airlineResponse || []

  const [error, seterror] = useState(false);
  const accumulatedMQResponsesRef = React.useRef([]);
  const { destinationPickup } = destinationPort;
  const { originPickup } = originPort;
  const [airportcode, setAirportcode] = useState({
    origincode: "",
    destinationcode: "",
  });
  const [selectedDate, setSelectedDate] = useState(0);
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedRows2, setExpandedRows2] = useState([]);

  const [indexTab, setTabIndex] = useState(0);
  const [show, setShow] = useState(0);
  const [open, setOpen] = useState(false);
  const [selecteddata, setSelecteddata] = useState({});
  const [viewBreakupData, setviewBreakupData] = useState({});
  const [openbooking, setOpenbooking] = useState(false);
  const [queryidall, setqueryidall] = useState({
    insertedRate: "",
    qatarrate: "",
    frieghtos: "",
  });

  const [commodityData, setCommodityData] = useState([]);
  const [comodity_des, setComodity_des] = useState("");
  // ADD — reads from the same Redux slice PageLayout already dispatches

  // Business verification (KYB) — only "approved" books (src/utils/kyb.js).
  const kycAccepted = isKybApproved(useSelector(kybstatus));


  function extractAirportCode(str) {
    const match = str.match(/\(([^)]+)\)/);
    return match ? match[1] : "";
  }
  // turnanble and stackable key logic
  function transformData(data) {
    const updatedPackages =
      data?.packagingDetails?.packagingType?.packages?.map((pkg) => {
        const handling = pkg?.handling;

        // Create new object without handling
        const newPkg = { ...pkg };
        delete newPkg?.handling;

        // Map handling → stackable + turnable
        if (handling === "Tiltable and Stackable") {
          newPkg.turnable = true;
          newPkg.stackable = true;
        } else if (handling === "Tiltable and Non-stackable") {
          newPkg.turnable = true;
          newPkg.stackable = false;
        } else if (handling === "Non-Tiltable and Stackable") {
          newPkg.turnable = false;
          newPkg.stackable = true;
        } else if (handling === "Non Tiltable and Non stackable") {
          newPkg.turnable = false;
          newPkg.stackable = false;
        }

        return newPkg;
      });

    return {
      ...data,
      packagingDetails: {
        ...data?.packagingDetails,
        packagingType: {
          ...data?.packagingDetails?.packagingType,
          packages: updatedPackages,
        },
      },
    };
  }
  useEffect(() => {
    const or = extractAirportCode(originPort.originAirport);
    const des = extractAirportCode(destinationPort.destinationAirport);
    setAirportcode({
      origincode: or,
      destinationcode: des,
    });
    let allcallpayloaddata = {
      cargoType: cargoType,
      originAirport: originPort,
      destinationAirport: destinationPort,
      goodsDetails: {
        cargoreadydate: goodsDetails?.cargoreadydate,
        commodityId: productDetails?.commodityId,
        specialHandlingCodes: productDetails?.specialHandlingCodes,
        commodity_description: commodity_description || productDetails?.natureOfGoods || "",
      },
      packagingDetails: packagingDetails,
      paymentTerms: paymentTerms,
      requestType: requestType,
      lowertempbound: lowertempbound,
      temperatureRange: temperatureRange,
      uppertempbound: uppertempbound,
      // IATA CASS code from the booking-history row (passed through as
      // `props.props` from the Queries page) so the /ratesearch/all payload
      // carries it in the manual-quote (magnifying-glass) flow too.
      iataCass: props?.props?.iataCass,
      // "productDetails":productDetails,
    };
    if (requestType == 2) {
      allcallpayloaddata.airlinePrefix = flightitinaries[0]?.airlinePrefix || null;
    }
    const result = transformData(allcallpayloaddata);
    let newresult;
    if (rqueryid) {
      newresult = {
        ...result,
        queryId: rqueryid ? rqueryid : "",
      };
    }
    if (requestType === "2") {
      newresult = {
        ...result,
        queryId: rqueryid,
        airwaybillNumber: airwaybillNumber,
      };
    }
    const finalresult = rqueryid ? newresult : result;
    getALLFlightRateSearch(finalresult, productDetails);
  }, []);
  const updatedNodeData = {
    ...searchratesAvailableData?.nodeData,
    searchquery: {
      ...searchratesAvailableData?.nodeData?.searchquery,
      // airlinepayloadData: airlinepayloadata, // Injecting the key
    },
  };
  const selectedCommodity = useMemo(() => {
    return commodityData?.find(
      (option) => parseInt(option?.id) === parseInt(props?.nodeData?.searchquery?.goodsDetails?.commodityId
      )
    );
  }, [commodityData, commodityId]);
  async function comodity_description() {
    const tokena = localStorage.getItem("tokenairline")
    const response = await axios.get(
      `https://cdutils.sgate.net/api/v1/new/commoditylist`,
      {
        headers: {
          Authorization: `Bearer ${tokena}`,
        },
      }
    );
    return response.data

  }





  useEffect(() => {
    const fetchCommodity = async () => {
      try {
        const data = await comodity_description();
        setCommodityData(data?.data);
      } catch (error) {
        console.error("Failed to fetch commodity data", error);
      }
    };

    fetchCommodity();
    dispatch(updatequeryid(props?.nodeData?.queryId))
    dispatch(updatemanualsearch(props?.props))

  }, [props]);
  useEffect(() => {
    if (selectedCommodity?.commodity_description) {
      setComodity_des(selectedCommodity?.commodity_description);
      // setCommoditydes(selectedCommodity.label);
    }
  }, [selectedCommodity]);
  useEffect(() => {
    const bookingiddata = {
      qrbookingid: Qrbookingid,
      frieghtosbookingid: bookingId,
    };
    dispatch(setBookingdata(bookingiddata));
  }, [Qrbookingid, bookingId]);

  
  useEffect(() => {


    if (props?.nodeData?.airlineResponse?.length > 0) {


      // Merge by date and sort
      const mergedByDate = mergeDataBasedOnDate(props?.nodeData?.airlineResponse);
      // Filter by origin and destination
      const filtered = mergedByDate.map((item) => ({
        ...item,
        availabilityResponseSOs: item?.availabilityResponseSOs?.filter(
          (so) =>
            so?.origin === airportcode?.origincode &&
            so?.destination === airportcode?.destinationcode
        ),
      }));
      // console.log(filtered, "filtered");

      // Apply min rate logic
      const finalMerged = findMinRate(filtered?.flat());
      // Update Redux state

      setMergedAirlineResponse({ airlineResponse: props?.nodeData?.airlineResponse }); //,updatedData

      dispatch(setsearchratesAvailableData(mergedAirlineResponse));
    }

  }, [props?.nodeData?.airlineResponse]);

  // Handle MQ_res socket responses from ManageSocketContext
  useEffect(() => {
    const MQ_res = receivingResponse?.MQ_res;
    if (!MQ_res) return;

    const mqNormalized = normalizeAirlineResponse(MQ_res?.airlineResponse);
    if (mqNormalized.length === 0) return;

    if (MQ_res?.queryId) {
      dispatch(updatequeryid(MQ_res.queryId));
      setqueryid(MQ_res.queryId);
    } else if (queryId) {
      dispatch(updatequeryid(queryId));
      setqueryid(queryId);
    }

    accumulatedMQResponsesRef.current = [
      ...accumulatedMQResponsesRef.current,
      ...mqNormalized,
    ];
    const merged = mergeDataBasedOnDate(accumulatedMQResponsesRef.current);
    const originCode = airportcode?.origincode;
    const destCode = airportcode?.destinationcode;
    const filtered = merged.map((item) => ({
      ...item,
      availabilityResponseSOs: (item?.availabilityResponseSOs || []).filter(
        (so) =>
          !originCode ||
          (so?.origin === originCode && so?.destination === destCode)
      ),
    }));
    const withRates = findMinRate(filtered);
    const finalResult = { ...MQ_res, airlineResponse: withRates };
    setMergedAirlineResponse(finalResult);
    dispatch(setsearchratesAvailableData(finalResult));
  }, [receivingResponse?.MQ_res, airportcode]);

  // find minimum rate
  const findMinRate = useCallback(
    (mergerdRes) => {
      const modifiedData = mergerdRes?.map((item) => {
        const availabilityList = item.availabilityResponseSOs || [];
        const Total_length_airline = availabilityList.length;

        const minRate = availabilityList?.reduce((min, curr) => {
          const currentRate = Number(
            curr?.rateDetails?.totalAmount || Infinity
          );
          return Math.min(min, currentRate);
        }, Infinity);

        return {
          ...item,
          minRate: minRate === Infinity ? 0 : minRate,
          rates_count: Total_length_airline,
        };
      });

      return modifiedData;
    },
    [hasMore]
  );
  // merge by date
  const mergeDataBasedOnDate = (searchResArray = []) => {
    const groupedByDate = {};

    for (const response of searchResArray) {
      const date = response?.departureDate;

      if (!groupedByDate[date]) {
        groupedByDate[date] = {
          ...response,
          availabilityResponseSOs: [...response.availabilityResponseSOs],
        };
      } else {
        const existingItems = groupedByDate[date]?.availabilityResponseSOs;
        for (const item of response?.availabilityResponseSOs) {
          const isDuplicate = existingItems?.some(
            (existing) => JSON.stringify(existing) === JSON.stringify(item)
          );

          if (!isDuplicate) {
            existingItems.push(item);
          }
        }
      }
    }
    // console.log(groupedByDate, "groupedByDate");

    // return Object.values(groupedByDate);
    return Object?.values(groupedByDate)?.sort(
      (a, b) => new Date(a.departureDate) - new Date(b.departureDate)
    );
  };

  const getALLFlightRateSearch = useCallback(
    async (allcallpayloaddata, product) => {
      let finalUpdatedPayload;
      //  if(allcallpayloaddata){
      const condition =
        allcallpayloaddata?.goodsDetails?.specialHandlingCodes.includes(
          "PEP"
        ) ||
        allcallpayloaddata?.goodsDetails?.specialHandlingCodes.includes("PER");

      const condition2 = product?.productCode === "QFR";
      const condition3 = allcallpayloaddata?.temperatureRange || false;
      // Same Perishables/temperature-range checks as the fresh-search flow
      // (getALLFlightRateSearch in Newratelisting.jsx) — without these, a
      // requestType "2" update never attached pharmaDtls for a Perishables
      // shipment with a temperature range selected unless it also happened to
      // carry a PEP/PER handling code + QFR product code.
      const isPerishableTempControlled =
        allcallpayloaddata?.goodsDetails?.commodityGroup?.toLowerCase() ===
        "perishables" && !!condition3;
      const isPerishablesNoTemp =
        allcallpayloaddata?.goodsDetails?.commodityGroup?.toLowerCase() ===
        "perishables no temp";
      const hasTempBounds =
        allcallpayloaddata?.uppertempbound != null &&
        allcallpayloaddata?.uppertempbound !== "" &&
        allcallpayloaddata?.lowertempbound != null &&
        allcallpayloaddata?.lowertempbound !== "";

      // Step 3: Create pharma-specific payloads
      const newUpdatePayload = {
        ...allcallpayloaddata,
        pharmaDtls: {
          pharmaReqType: "Care",
          isPassive: false,
        },
      };

      const newUpdatePayload2 = {
        ...allcallpayloaddata,
        pharmaDtls: {
          pharmaReqType: "Passive",
          // Shared with the booking payload builder so the frozen "-10"
          // set-point nulls its temperature fields identically in both — the
          // form stores -10/-30 for that option, but it is a set-point rather
          // than a from/to window and those bounds must not go out.
          passivePharmaDtl: buildPassivePharmaDtl(allcallpayloaddata),
          isPassive: true,
        },
      };

      // Step 4: Choose which payload to use

      if (
        (condition === true && condition2 === true && condition3) ||
        (condition === false && condition2 === true)
      ) {
        finalUpdatedPayload = newUpdatePayload2;
      } else if (
        condition === true &&
        condition2 === true &&
        condition3 === false
      ) {
        finalUpdatedPayload = newUpdatePayload;
      } else if (isPerishableTempControlled) {
        finalUpdatedPayload = newUpdatePayload2;
      } else if (isPerishablesNoTemp && hasTempBounds) {
        finalUpdatedPayload = newUpdatePayload2;
      } else {
        finalUpdatedPayload = allcallpayloaddata;
      }

      // Step 5: Add temperature-based special handling codes
      const tempRange = allcallpayloaddata?.temperatureRange;

      if (tempRange === "2-8") {
        finalUpdatedPayload = {
          ...finalUpdatedPayload,
          goodsDetails: {
            ...finalUpdatedPayload?.goodsDetails,
            specialHandlingCodes: [
              ...(finalUpdatedPayload?.goodsDetails?.specialHandlingCodes ||
                []),
              "CRT",
            ],
          },
        };
      } else if (tempRange === "15-25") {
        finalUpdatedPayload = {
          ...finalUpdatedPayload,
          goodsDetails: {
            ...finalUpdatedPayload?.goodsDetails,
            specialHandlingCodes: [
              ...(finalUpdatedPayload?.goodsDetails?.specialHandlingCodes ||
                []),
              "COL",
            ],
          },
        };
      } else if (tempRange === "2-25") {
        finalUpdatedPayload = {
          ...finalUpdatedPayload,
          goodsDetails: {
            ...finalUpdatedPayload?.goodsDetails,
            specialHandlingCodes: [
              ...(finalUpdatedPayload?.goodsDetails?.specialHandlingCodes ||
                []),
              "ERT",
            ],
          },
        };

        // }
      }
      try {
        const rateResponse = await httpinstance.post(
          "ratesearch/all",
          finalUpdatedPayload
        );
      } catch (err) { }
    },
    [props]
  );
  const handleDateChange = (event, newValue) => {
    setSelectedDate(newValue);
    setTabIndex(newValue);
    // Collapse any expanded itinerary cards when switching tabs, so a card left
    // open on one date isn't still open when the user comes back to it.
    setExpandedRows([]);
    setExpandedRows2([]);
  };

  const toggleRow = (index) => {
    setExpandedRows((prev) => (prev.includes(index) ? [] : [index]));
  };
  const toggleRow2 = (index) => {
    // console.log( index,"index");
    setExpandedRows2((prev) => (prev.includes(index) ? [] : [index]));
  };

  const convertMinutesToHoursAndMinutes = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  };
  //  manual quotation
  const checkForKam_user = () => {
    if (props?.role_type != undefined) {
      return !props?.role_type;
    } else if (
      props?.nodeData?.isExpired != undefined &&
      props?.nodeData?.isExpired
    ) {
      return props?.nodeData?.isExpired;
    }
    return false;
  };

  const convertMinutesToDaysHoursMinutes = (totalMinutes) => {
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    return `${days}d ${hours}h ${minutes}m`;
  };
  function formatDateTime(dateTimeString) {
    const date = new Date(dateTimeString); // Convert input string to Date object

    if (isNaN(date.getTime())) {
      throw new Error(
        "Invalid date format. Expected format: Month Day, Year HH:MM AM/PM (e.g., March 7, 2025 3:45 AM)"
      );
    }

    // Format the date as DD-MMM-YYYY
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    // Format the time as HH:MM AM/PM
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert 24-hour format to 12-hour format
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  }
  const handleCheckBooking = (option) => {
    
    setSelecteddata(option);
    
    setOpen(1);
  };
  // viewbreakup
  const checkViewBreakuUp = async (option) => {
    
    const params = {
      origin: airportcode?.origincode,
      destination: airportcode?.destinationcode,
      incoTerms: searchquery?.paymentTerms?.incoTerms,
      optionalVas:
        searchquery?.paymentTerms?.optionalVas?.map((item) => item?.vatId) ||
        [],
      totalWeight: packagingDetails?.shipmentTotal?.totalweight,
      freightCharges: option?.rateDetails?.freightCharges,
    };
    if (originPickup) {
      params.pickupCharges = option?.rateDetails?.pickupCharges;
    }
    if (destinationPickup) {
      params.deliveryCharges = option?.rateDetails?.deliveryCharges;
    }
    if (rqueryid != "") {
      params.queryid = rqueryid;
    }
    try {
      const response = await dispatch(viewBreakUp(params));
      setviewBreakupData(response?.payload?.data?.data);
      setShow(1);
      // console.log("hiy",response?.payload.data?.data);
    } catch (err) { }
  };
  const countFlightsForDate = (dateIndex) => {
    return (
      availabilityResponseSOs?.[dateIndex]?.availabilityResponseSOs?.length || 0
    );
  };

  const handleback = () => {
    setAirres(true);
    clearSearchRateAvailableData();
    setReceivingResponse(null);
    // dispatch(setsearchratesAvailableData({}));

    navigate(-1);
  };
  // manual quote
  const redirectToeditManualQuote = () => {
    dispatch(getManualQuoteDetailById(props?.nodeData?.manualQuoteId)).then(
      (res) => {
        const payload = {
          manualQuoteDetails: res?.payload?.nodeData,
          queryDetails: res?.payload?.nodeData?.queryId,
        };
        dispatch(setManualQuoteDetail(payload));
        navigate("/send-manual-quote-v2");
      }
    );
  };

  // const getListOfDate = () => {
  //   // const { routingPreference } = props.nodeData;
  //   // const { scheduledDepartureDate } = routingPreference;
  //   const startDate = moment(scheduledDepartureDate);
  //   const days = 5;
  //   const dateList = [];
  //   for (let i = 0; i < days; i++) {
  //     dateList.push(startDate.clone().add(i, "days").format("DD-MMM-YYYY"));
  //   }
  //   return dateList;
  // };

  const checkifItEmptyOrNot = () => {
    const findLength =
      availabilityResponseSOs?.[0]?.availabilityResponseSOs?.length;
    return findLength;
  };
  return error?.hasnodata == true ? (
    <FailureSearchRate />
  ) : (
    <>
      <ToastContainer
        position="top-center"
        autoClose={7000}
        limit={1}
        toastStyle={{ backgroundColor: "#ffffff", color: "#1a1a1a" }}
        style={{
          "--toastify-color-info": "#FACC15",
          "--toastify-icon-color-info": "#FACC15",
          "--toastify-color-progress-info": "#FACC15",
        }}
      />
      {/* {bookingstatus==="Booking Confirmed" && availabilityResponseSOs?.[0]?.availabilityResponseSOs?.length==0 && <NoDataPage />} */}
      <Box
        sx={{ padding: 2, backgroundColor: "#f5f5f5" }}
        className="edit_queryMain"
      >
        {props?.role_type != undefined && !props?.role_type ? null : (
          <Paper
            className="airpadding0"
            sx={{
              mb: 2,
              backgroundColor: "#fff9eb",
              borderRadius: 3,
              border: "1.5px solid #F5D98A",
              boxShadow: "0 1px 4px rgba(239,166,3,0.12)",
              padding: 0,
              overflow: 'hidden',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'stretch', width: '100%' }}>
              {/* Back / Edit Query button */}
              <div style={{ flexShrink: 0 }}>
                <Box
                  className="edit-query_paragraph"
                  sx={{
                    backgroundColor: "#fff9eb",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    position: 'relative',
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      right: 0,
                      top: '10%',
                      height: '80%',
                      width: '2px',
                      background: 'linear-gradient(to bottom, transparent, #F5C842 30%, #F5C842 70%, transparent)',
                      borderRadius: '2px',
                    },
                  }}
                >
                  {props?.role_type !== undefined && props?.role_type ? (
                    <Typography sx={{ fontSize: "35px", margin: "8px" }}>
                      <div
                        onClick={() => navigate("/queries")}
                        className="relative backimgg circleripp pulse bg-[#fff9eb] text-center flex items-center justify-center"
                      >
                        {props?.image}
                        <ChevronLeft className="w-[35px] h-[40px] inline-block" />
                      </div>
                    </Typography>
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '5px',
                        cursor: 'default',
                        padding: '10px 18px',
                        pointerEvents: 'none',
                        opacity: 0.4,
                      }}
                    >
                      <Box
                        className="back-icon-box"
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: '10px',
                          border: '1.5px solid #EFA603',
                          backgroundColor: 'white',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'background-color 0.2s',
                          boxShadow: '0 1px 4px rgba(239,166,3,0.18)',
                        }}
                      >
                        <ArrowBackIcon sx={{ color: '#EFA603', fontSize: 16 }} />
                      </Box>
                    </Box>
                  )}
                </Box>
              </div>

              {/* Origin → Destination + chips */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', py: '10px', px: '14px', flexWrap: 'nowrap' }}>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", minWidth: 90 }}>
                    <Typography sx={{ fontSize: "20px", fontWeight: 800, color: "#111", lineHeight: 1, letterSpacing: "-0.5px", fontFamily: "Arial, sans-serif" }}>
                      {airportcode?.origincode}
                    </Typography>
                    <Typography sx={{ mt: "4px", fontSize: "11px", fontWeight: 500, color: "#8c8c8c", textTransform: "uppercase", letterSpacing: "0.4px", lineHeight: 1 }}>
                      {originPort?.origincountryName}
                    </Typography>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Box sx={{ width: '44px', borderBottom: '2px dashed #FFC107', flexShrink: 0 }} />
                    <Box sx={{ mx: 1.2, width: 40, height: 40, borderRadius: '50%', border: '1.5px solid #FFC107', backgroundColor: '#fff9eb', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 1px 4px rgba(255,193,7,0.18)' }}>
                      <FlightIcon sx={{ color: '#EFA603', fontSize: 20, transform: 'rotate(90deg)' }} />
                    </Box>
                    <Box sx={{ width: '44px', borderBottom: '2px dashed #FFC107', flexShrink: 0 }} />
                    <Box sx={{ width: 0, height: 0, borderTop: '6px solid transparent', borderBottom: '6px solid transparent', borderLeft: '9px solid #FFC107', flexShrink: 0 }} />
                  </Box>

                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 58 }}>
                    <Typography sx={{ fontSize: 22, fontWeight: 800, color: '#1a1a1a', lineHeight: 1 }}>
                      {airportcode?.destinationcode}
                    </Typography>
                    <Typography sx={{ fontSize: 10, color: '#888', mt: '3px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      {destinationPort?.destinationcountryName}
                    </Typography>
                  </Box>

                  <Box sx={{ width: '1.5px', height: 38, background: 'linear-gradient(to bottom, transparent, #F5C842 20%, #F5C842 80%, transparent)', mx: 2, flexShrink: 0, alignSelf: 'center' }} />

                  <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
                    {(() => {
                      const shipTotal = props?.nodeData?.searchquery?.packagingDetails?.shipmentTotal;
                      const vol = shipTotal?.totalvolume;
                      const gw = shipTotal?.totalweight;
                      const vw = shipTotal?.volumeWeight;
                      const cw = shipTotal?.chargeableWeight;
                      const wunit = shipTotal?.weightunit || 'KG';
                      // Opened cold (no live search in redux) the range only
                      // exists on the stored query, so fall back to nodeData.
                      const tempRange = formatTemperatureRange(
                        temperatureRange || props?.nodeData?.searchquery?.temperatureRange
                      );
                      return [
                        { icon: <CalendarTodayIcon sx={{ fontSize: 12, color: '#EFA603' }} />, label: goodsDetails?.cargoreadydate },
                        { icon: <CategoryIcon sx={{ fontSize: 12, color: '#EFA603' }} />, label: comodity_des || null },
                        // Temperature-controlled searches only — '' for the rest,
                        // so the .filter below drops the chip entirely.
                        { icon: <AcUnitIcon sx={{ fontSize: 12, color: '#0EA5E9' }} />, label: tempRange || null },
                        { label: shipTotal?.totalunits ? `${shipTotal.totalunits} Units` : null },
                        { label: vol != null ? `${Number(vol).toFixed(4)} ${shipTotal?.unit || 'CBM'}` : null },
                        { label: gw != null ? `G.W ${Number(gw).toFixed(2)} ${wunit}` : null },
                        { label: vw != null ? `V.W ${Number(vw).toFixed(2)} ${wunit}` : null },
                        { label: cw != null ? `C.W ${Number(cw).toFixed(2)} ${wunit}` : null },
                      ].filter((c) => c.label);
                    })().map((chip, i) => (
                      <Box
                        key={i}
                        sx={{
                          padding: '4px 10px',
                          borderRadius: '20px',
                          border: '1px solid #e8e8e8',
                          backgroundColor: 'white',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                          flexShrink: 0,
                          boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                        }}
                      >
                        {chip.icon && chip.icon}
                        <Typography sx={{ fontSize: '12px', color: '#555', fontWeight: 400, whiteSpace: 'nowrap' }}>
                          {chip.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </div>

              {/* Clock Section */}
              {props?.nodeData?.isExpired !== undefined && (
                <div className="2xl:col-span-2 xl:col-span-2 lg:col-span-2 md:col-span-2 col-span-12">
                  <div className="text-center h-full flex items-center justify-center px-3">
                    <div
                      className="text-center text-sm"
                      style={{ color: props?.nodeData?.isExpired ? "red" : "blue" }}
                    >
                      <i><Clock8 className="inline-block" /></i>
                      <div className="linedecrease leading-[14px] mt-1">
                        <h4 className="font-bold">
                          {props?.nodeData?.isExpired ? "Quote Expired" : "Quote expiring in"}
                        </h4>
                        {!props?.nodeData?.isExpired && convertMinutesToDaysHoursMinutes(props?.nodeData?.minutesUntilExpiry)}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Paper>
        )}

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Typography>
            {/* Tab bar */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                backgroundColor: 'white',
                padding: '12px 16px',
                overflowX: 'auto',
                borderRadius: '12px',
                border: '1px solid #f0ede8',
              }}
            >
              <Tabs
                value={selectedDate}
                onChange={handleDateChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ minHeight: 'unset', '& .MuiTabs-indicator': { display: 'none' } }}
              >
                {hasMore && (checkifItEmptyOrNot() === 0 || checkifItEmptyOrNot() === undefined) && (
                  <Tab
                    disabled
                    value={-1}
                    label={
                      <div className="Tabtopskeltibg flex">
                        {Array.from({ length: 3 }).map((_, i) => (
                          <div key={i} className="Stabbook text-center mr-3">
                            <p className="Kline w-[80px] h-[20px] mb-1 block m-auto"></p>
                            <p className="Kline w-[100px] h-[20px] mb-1"></p>
                          </div>
                        ))}
                      </div>
                    }
                  />
                )}
                {availabilityResponseSOs?.map((item, index) => {
                  if (!item?.availabilityResponseSOs?.length) return null;
                  const date = moment(item?.availabilityResponseSOs[0]?.flightItineraries[0]?.scheduledDepartureDate);
                  const isActive = selectedDate === index;
                  if (hasMore && checkifItEmptyOrNot() - 1 === index) {
                    return (
                      <Tab
                        key={index}
                        value={index}
                        disableRipple
                        sx={{ minHeight: 'unset', padding: 0, marginRight: '10px' }}
                        label={
                          <div className="Tabtopskeltibg flex">
                            {Array.from({ length: 3 }).map((_, i) => (
                              <div key={i} className="Stabbook text-center mr-3">
                                <p className="Kline w-[80px] h-[20px] mb-1 block m-auto"></p>
                                <p className="Kline w-[100px] h-[20px] mb-1"></p>
                              </div>
                            ))}
                          </div>
                        }
                      />
                    );
                  }
                  return (
                    <Tab
                      key={index}
                      value={index}
                      disableRipple
                      sx={{ minHeight: 'unset', padding: 0, marginRight: '10px' }}
                      label={
                        <Box
                          sx={{
                            minWidth: 90,
                            padding: '8px 14px',
                            borderRadius: '8px',
                            border: isActive ? '2px solid #4CAF50' : '1px solid #f0f0f0',
                            backgroundColor: isActive ? '#F1F8E9' : 'white',
                            textAlign: 'center',
                            position: 'relative',
                            transition: 'all 0.2s',
                            cursor: 'pointer',
                          }}
                        >
                          {isActive && (
                            <Box sx={{ position: 'absolute', top: 6, right: 6, width: 6, height: 6, borderRadius: '50%', backgroundColor: '#4CAF50' }} />
                          )}
                          <Typography sx={{ fontSize: '11px', color: isActive ? '#888' : '#aaa' }}>
                            {date.format('DD MMM YYYY')}
                          </Typography>
                          {item?.rates_count > 0 ? (
                            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: isActive ? '#FFC107' : '#888', mt: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                              ₹{Number(item?.minRate).toLocaleString('en-IN')}
                              <Box component="span" sx={{ fontSize: '10px', fontWeight: 'bold', color: isActive ? '#FFD54F' : '#AAA' }}>
                                Onwards
                              </Box>
                            </Typography>
                          ) : hasMore ? (
                            <Typography sx={{ fontSize: '11px', color: '#aaa', mt: '2px' }}>Loading...</Typography>
                          ) : (
                            <Typography sx={{ fontSize: '11px', color: 'error.main', fontStyle: 'italic', mt: '2px' }}>No results</Typography>
                          )}
                        </Box>
                      }
                    />
                  );
                })}
              </Tabs>
            </Box>
          </Typography>

          <Typography sx={{ overflowX: 'auto', display: 'block' }}>
            <Box
              sx={{
                backgroundColor: 'white',
                borderRadius: '12px',
                border: '1px solid #f0ede8',
                padding: '12px 12px',
                minWidth: '900px',
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }} className="listingbookked">

                {/* Skeleton when loading with no data */}
                {hasMore && (checkifItEmptyOrNot() === undefined || checkifItEmptyOrNot() === 0) && (
                  <>
                    {Array.from({ length: 6 }).map((_, index) => (
                      <div className="mt-5" key={`skeleton-${index}`}>
                        <div className="listingSkelton">
                          <div className="Klistingbooked Klistingbookpadding">
                            <div className="Kairlogo ">
                              <figure className="Kline w-[100px] h-[20px] mb-1 "></figure>
                              <p className="Kline w-[100px] h-[20px] mb-1"></p>
                            </div>
                            <div className="Kairldesination text-center">
                              <figure className="Kline w-[35px] h-[35px] mb-1 rounded-full block m-auto"></figure>
                              <p className="Kline w-[100px] h-[20px] mb-1"></p>
                            </div>
                            <div className="Ktimemain gap-x-5">
                              <div className="Ktimestart ">
                                <p className="Kline w-[100px] h-[20px] mb-1"></p>
                                <p className="Kline w-[100px] h-[20px]"></p>
                              </div>
                              <div className="KtimeTotal ">
                                <p className="Kline w-[100px] h-[20px] mb-1"></p>
                              </div>
                              <div className="Ktimestart ">
                                <p className="Kline w-[100px] h-[20px] mb-1"></p>
                                <p className="Kline w-[100px] h-[20px]"></p>
                              </div>
                            </div>
                            <div className="vewmorebox ">
                              <p className="Kline w-[100px] h-[16px] mb-1"></p>
                              <p className="Kline w-[100px] h-[20px]"></p>
                            </div>
                            <div className="vewmorebox ">
                              <p className="Kline w-[100px] h-[30px] mb-1"></p>
                            </div>
                          </div>
                          <div className="KlistingBottom Klistingbookpadding">
                            <div className="Kservicebttom flex items-center">
                              <figure className="Kline2 w-[24px] h-[24px] mb-1 rounded-full block m-auto mr-2"></figure>
                              <p className="Kline2 w-[80px] h-[10px] mb-1"></p>
                            </div>
                            <div className="servicebttomToggle">
                              <p className="Kline2 w-[20px] h-[10px] mb-1"></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {/* Table column headers */}
                {availabilityResponseSOs?.[indexTab]?.availabilityResponseSOs?.length > 0 && (
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: '40px 120px 1fr 145px 135px 80px 160px',
                      gap: 1,
                      padding: '6px 20px 6px 24px',
                      mb: '4px',
                    }}
                  >
                    <Box />
                    {['Carrier', 'Itinerary', 'Departure', 'Arrival', 'Duration', 'Price'].map((col) => (
                      <Typography
                        key={col}
                        sx={{
                          fontSize: '11px',
                          fontWeight: 700,
                          color: '#a8a29e',
                          textTransform: 'uppercase',
                          letterSpacing: '0.8px',
                          textAlign: 'center',
                          justifySelf: 'center',
                          ...(col === 'Itinerary' && { width: '75%' }),
                        }}
                      >
                        {col}
                      </Typography>
                    ))}
                  </Box>
                )}

                {/* Rate cards */}
                {availabilityResponseSOs?.[indexTab]?.availabilityResponseSOs?.map((option, index) => {
                  const checkItinerary = option?.flightItineraries?.length > 1;
                  const _item = option?.flightItineraries?.[0];
                  const scheduledArrivalTime = option?.flightItineraries?.[option.flightItineraries.length - 1]?.scheduledArrivalTime;
                  const isRowExpanded = expandedRows?.includes(index);
                  const checkAirline = option?.flightItineraries?.[0]?.carrierCode === "020";
                  const airline = option?.flightItineraries?.[0]?.carr_name;
                  const numStops = (option?.flightItineraries?.length ?? 1) - 1;
                  const stopViaAirports = option?.flightItineraries?.slice(0, -1)?.map((f) => f?.segmentOfArrival).join(', ');

                  const serviceType =
                    option?.productCommodityDetails?.specialHandlingCodes?.includes("XPS")
                      ? `${_item?.carrierCode} Plus`
                      : option?.productCommodityDetails?.specialHandlingCodes?.includes("VIC")
                        ? `${_item?.carrierCode} Prime`
                        : `${_item?.carrierCode} General`;

                  return (
                    <Box key={index} sx={{ mb: '6px' }}>
                      <Paper
                        sx={{
                          backgroundColor: isRowExpanded ? '#FFFDF5' : '#fff',
                          borderRadius: '10px',
                          overflow: 'hidden',
                          boxShadow: isRowExpanded ? '0 2px 10px rgba(255,193,7,0.18)' : '0 1px 4px rgba(0,0,0,0.07)',
                          border: isRowExpanded ? '1px solid #FFE082' : '1px solid #f0ede8',
                          borderLeft: '4px solid #FFC107',
                          transition: 'box-shadow 0.2s, background-color 0.2s',
                        }}
                      >
                        {/* Main row */}
                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '40px 100px 1fr 145px 135px 80px 160px',
                            gap: 1,
                            alignItems: 'center',
                            justifyItems: 'center',
                            textAlign: 'center',
                            padding: '10px 16px',
                            cursor: 'pointer',
                            '&:hover': { backgroundColor: 'rgba(255,248,225,0.5)' },
                            transition: 'background-color 0.15s',
                          }}
                          onClick={() => toggleRow(index)}
                        >
                          {/* Chevron */}
                          <IconButton
                            size="small"
                            sx={{ padding: '4px' }}
                            onClick={(e) => { e.stopPropagation(); toggleRow(index); }}
                          >
                            {isRowExpanded ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
                          </IconButton>

                          {/* Carrier */}
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                            <img
                              src={option?.flightItineraries?.[0]?.carrierLogo || airlinelogo}
                              style={{ width: 50, height: 50, objectFit: 'contain' }}
                              alt=""
                            />
                            <Typography sx={{ fontSize: '10px', fontWeight: 600, color: '#333', textAlign: 'center', lineHeight: 1.2 }}>
                              {airline}
                            </Typography>
                          </Box>

                          {/* Itinerary */}
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '75%' }}>
                              <Box sx={{ width: 10, height: 12, borderRadius: '50%', backgroundColor: '#EFA603', flexShrink: 0 }} />
                              <Box sx={{ flex: 1, height: '3px', backgroundImage: 'repeating-linear-gradient(to right, #EFA603 0 12px, transparent 12px 20px)' }} />
                              {numStops > 0 && Array.from({ length: numStops }).map((_, si) => (
                                <React.Fragment key={si}>
                                  <Box sx={{ width: 8, height: 10, borderRadius: '50%', border: '2.5px solid #EFA603', backgroundColor: 'white', flexShrink: 0 }} />
                                  <Box sx={{ flex: 1, height: '3px', backgroundImage: 'repeating-linear-gradient(to right, #EFA603 0 12px, transparent 12px 20px)' }} />
                                </React.Fragment>
                              ))}
                              <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#EFA603', flexShrink: 0 }} />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', mt: '2px' }}>
                              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#555' }}>{option?.origin}</Typography>
                              <FlightIcon sx={{ color: '#888', fontSize: '14px' }} />
                              {numStops > 0 && <Typography sx={{ fontSize: '13px', color: '#888', letterSpacing: '2px' }}>...</Typography>}
                              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#555' }}>{option?.destination}</Typography>
                            </Box>
                            <Typography sx={{ fontSize: '11px', color: '#999', textAlign: 'center' }}>
                              {numStops === 0 ? 'Direct' : `${numStops} stop${numStops > 1 ? 's' : ''} via ${stopViaAirports}`}
                            </Typography>
                          </Box>

                          {/* Departure */}
                          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#1a1a1a', whiteSpace: 'nowrap' }}>
                            {moment(_item?.scheduledDepartureTime).format('DD/MM/YYYY HH:mm')}
                          </Typography>

                          {/* Arrival */}
                          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#1a1a1a', whiteSpace: 'nowrap' }}>
                            {moment(scheduledArrivalTime).format('DD/MM/YYYY HH:mm')}
                          </Typography>

                          {/* Duration */}
                          <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#EFA603' }}>
                            {convertMinutesToHoursAndMinutes(option?.travelTime)}
                          </Typography>

                          {/* Price + Book */}
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              alignSelf: 'stretch',
                              backgroundColor: '#FFFDE7',
                              border: '1px solid #FFE082',
                              margin: '8px 8px 8px 0',
                              padding: '10px 12px',
                              minWidth: '140px',
                              borderRadius: '8px',
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <Typography sx={{ fontSize: '17px', fontWeight: 500, color: '#0b0b0b', whiteSpace: 'nowrap', lineHeight: 1.2 }}>
                              {formatrates(option?.rateDetails?.totalAmount)}
                            </Typography>
                            {option?.rateDetails?.ratePerkilo != null && (
                              <Typography sx={{ fontSize: '12px', color: '#888', whiteSpace: 'nowrap' }}>
                                ₹{Number(option?.rateDetails?.ratePerkilo).toLocaleString('en-IN')} /kg
                              </Typography>
                            )}
                            {props?.nodeData?.isAllreadyBooked !== undefined && props?.nodeData?.isAllreadyBooked ? (
                              <Button variant="contained" fullWidth disabled sx={{ fontSize: '12px', fontWeight: 700, py: '6px', '&.Mui-disabled': { bgcolor: 'grey.300', color: 'text.primary' } }}>
                                Already Booked
                              </Button>
                            ) : props?.nodeData?.isExpired !== undefined && props?.nodeData?.isExpired ? (
                              <Button variant="contained" fullWidth disabled sx={{ fontSize: '12px', fontWeight: 700, py: '6px', '&.Mui-disabled': { bgcolor: 'grey.300', color: 'text.primary' } }}>
                                Quote Expired
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                fullWidth
                                disabled={checkForKam_user() || !kycAccepted}
                                sx={{
                                  fontSize: '12px',
                                  fontWeight: 400,
                                  color: '#000000',
                                  letterSpacing: '1px',
                                  textTransform: 'uppercase',
                                  py: '6px',
                                  backgroundColor: '#ffc107',
                                  '&:hover': { backgroundColor: '#d4940a', color: '#000000' },
                                  ...((checkForKam_user() || !kycAccepted) && {
                                    '&.Mui-disabled': { bgcolor: 'grey.300', color: 'rgba(15,15,15,0.39)' },
                                  }),
                                }}
                                onClick={() => handleCheckBooking(option, checkAirline)}
                              >
                                Book Now
                              </Button>
                            )}
                          </Box>
                        </Box>

                        {/* Expanded section */}
                        <Collapse in={isRowExpanded} timeout="auto" unmountOnExit>
                          <Box sx={{ backgroundColor: '#FFFDF5', borderTop: '1px solid #FFE082', padding: '16px 24px' }}>
                            <TableContainer
                              sx={{
                                border: '1px solid #E5E5E5',
                                borderRadius: '16px',
                                overflow: 'hidden',
                                backgroundColor: '#fff',
                              }}
                            >
                              <Table size="small">
                                <TableHead>
                                  <TableRow sx={{ backgroundColor: '#FAFAFA', borderBottom: '1px solid #ECECEC' }}>
                                    {['Carrier', 'Route', 'Departure', 'Arrival', 'Duration', 'Aircraft', 'Flight #'].map((h) => (
                                      <TableCell
                                        key={h}
                                        sx={{
                                          py: 2,
                                          borderBottom: 'none',
                                          fontSize: '12px',
                                          fontWeight: 500,
                                          color: '#9A9A9A',
                                          textTransform: 'uppercase',
                                          letterSpacing: '0.4px',
                                        }}
                                      >
                                        {h}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {option?.flightItineraries?.map((detail, idx) => {
                                    const isNotLast = idx < option?.flightItineraries?.length - 1;
                                    let layoverText = null;
                                    if (isNotLast) {
                                      const nextFlight = option?.flightItineraries?.[idx + 1];
                                      const layoverMins = moment(nextFlight?.scheduledDepartureTime).diff(moment(detail?.scheduledArrivalTime), 'minutes');
                                      if (layoverMins > 0) layoverText = `Layover at ${detail?.segmentOfArrival} — ${convertMinutesToHoursAndMinutes(layoverMins)}`;
                                    }
                                    return (
                                      <React.Fragment key={idx}>
                                        <TableRow sx={{ '&:hover': { backgroundColor: '#FCFCFC' }, '& td': { borderBottom: '1px solid #F1F1F1', py: 2.2 } }}>
                                          <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                              <Box sx={{ width: 38, height: 38, borderRadius: '8px', border: '1px solid #EEE', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>
                                                <img src={detail?.ailinelogoUrl || airlinelogo} alt="" style={{ width: 35, height: 35, objectFit: 'contain' }} />
                                              </Box>
                                              <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#111' }}>
                                                {detail?.carr_name}
                                              </Typography>
                                            </Box>
                                          </TableCell>
                                          <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                              <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#111' }}>{detail?.segmentOfDeparture}</Typography>
                                              <FlightIcon sx={{ fontSize: '13px', color: '#EFA603' }} />
                                              <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#111' }}>{detail?.segmentOfArrival}</Typography>
                                            </Box>
                                          </TableCell>
                                          <TableCell>
                                            <Typography sx={{ fontSize: '13px', color: '#333' }}>
                                              {moment(detail?.scheduledDepartureTime).format('DD/MM/YYYY HH:mm')}
                                            </Typography>
                                          </TableCell>
                                          <TableCell>
                                            <Typography sx={{ fontSize: '13px', color: '#333' }}>
                                              {moment(detail?.scheduledArrivalTime).format('DD/MM/YYYY HH:mm')}
                                            </Typography>
                                          </TableCell>
                                          <TableCell>
                                            <Typography sx={{ fontSize: '13px', color: '#EFA603', fontWeight: 600 }}>
                                              {detail?.travelTime ? detail?.travelTime : '-'}
                                            </Typography>
                                          </TableCell>
                                          <TableCell>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                              <img src="https://staging.sgate.in/html/designer/freightsee/aircraft.png" style={{ width: 13, height: 13 }} alt="" />
                                              <Typography sx={{ fontSize: '12px' }}>{detail?.carrierAircraftType}</Typography>
                                            </Box>
                                          </TableCell>
                                          <TableCell>
                                            <Typography sx={{ fontSize: '12px' }}>
                                              {detail?.carrierCode === 'TK' ? '' : detail?.carrierCode}{detail?.carrierNumber}
                                            </Typography>
                                          </TableCell>
                                        </TableRow>
                                        {layoverText && (
                                          <TableRow>
                                            <TableCell colSpan={7} sx={{ textAlign: 'center', backgroundColor: '#FFF8E1', padding: '6px', borderTop: '1px dashed #FFE082' }}>
                                              <Typography sx={{ fontSize: '12px', color: '#856404', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                                                <span>🕐</span> {layoverText}
                                              </Typography>
                                            </TableCell>
                                          </TableRow>
                                        )}
                                      </React.Fragment>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        </Collapse>

                        {/* Inline skeleton when streaming more results */}
                        {hasMore && (checkifItEmptyOrNot() === undefined || checkifItEmptyOrNot() - 1 === index) && (
                          <>
                            {Array.from({ length: 6 }).map((_, skIdx) => (
                              <div className="mt-5" key={`sk-${skIdx}`}>
                                <div className="listingSkelton">
                                  <div className="Klistingbooked Klistingbookpadding">
                                    <div className="Kairlogo ">
                                      <figure className="Kline w-[100px] h-[20px] mb-1 "></figure>
                                      <p className="Kline w-[100px] h-[20px] mb-1"></p>
                                    </div>
                                    <div className="Kairldesination text-center">
                                      <figure className="Kline w-[35px] h-[35px] mb-1 rounded-full block m-auto"></figure>
                                      <p className="Kline w-[100px] h-[20px] mb-1"></p>
                                    </div>
                                    <div className="Ktimemain gap-x-5">
                                      <div className="Ktimestart ">
                                        <p className="Kline w-[100px] h-[20px] mb-1"></p>
                                        <p className="Kline w-[100px] h-[20px]"></p>
                                      </div>
                                      <div className="KtimeTotal ">
                                        <p className="Kline w-[100px] h-[20px] mb-1"></p>
                                      </div>
                                      <div className="Ktimestart ">
                                        <p className="Kline w-[100px] h-[20px] mb-1"></p>
                                        <p className="Kline w-[100px] h-[20px]"></p>
                                      </div>
                                    </div>
                                    <div className="vewmorebox ">
                                      <p className="Kline w-[100px] h-[16px] mb-1"></p>
                                      <p className="Kline w-[100px] h-[20px]"></p>
                                    </div>
                                    <div className="vewmorebox ">
                                      <p className="Kline w-[100px] h-[30px] mb-1"></p>
                                    </div>
                                  </div>
                                  <div className="KlistingBottom Klistingbookpadding">
                                    <div className="Kservicebttom flex items-center">
                                      <figure className="Kline2 w-[24px] h-[24px] mb-1 rounded-full block m-auto mr-2"></figure>
                                      <p className="Kline2 w-[80px] h-[10px] mb-1"></p>
                                    </div>
                                    <div className="servicebttomToggle">
                                      <p className="Kline2 w-[20px] h-[10px] mb-1"></p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </Paper>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Typography>
        </Box>
      </Box>

      <AlertDialogBox
        open={show}
        type="cancelBooking"
        textMessage="Charges Breakdown"
        handleBack={() => navigate(-1)}
        handleClose={() => setShow(0)}
        customheight={"fit"}
        customwidth={"fit"}
      >
        <TableContainer>
          <Table>
            <TableBody>
              {originPickup && viewBreakupData?.pickupCharges > 0 && (
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      <img
                        src={pickup}
                        alt="Origin"
                        style={{ width: 40, height: 40, marginRight: 10 }}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body1">
                      <strong>Pickup Charges:</strong>
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: "right" }}>
                    <Typography variant="body1">
                      {formatrates(viewBreakupData?.pickupCharges)}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {viewBreakupData?.OriginCharges > 0 && (
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      <img
                        src={originimg}
                        alt="Origin"
                        style={{ width: 40, height: 40, marginRight: 10 }}
                      />
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body1">
                      <strong>Origin Charges:</strong>
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: "right" }}>
                    <Typography variant="body1">
                      {formatrates(viewBreakupData?.OriginCharges?.toFixed(2))}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell>
                  <Typography variant="body1">
                    <img
                      src={airfreight}
                      alt="Origin"
                      style={{ width: 40, height: 40, marginRight: 10 }}
                    />
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body1">
                    <strong>Air Freight charges:</strong>
                  </Typography>
                </TableCell>
                <TableCell sx={{ textAlign: "right" }}>
                  <Typography variant="body1">
                    {formatrates(viewBreakupData?.AirFreight?.toFixed(2))}
                  </Typography>
                </TableCell>
              </TableRow>

              {viewBreakupData?.DestinationCharges > 0 && (
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      <img
                        src={destinationimg}
                        alt="destinationimg"
                        style={{ width: 40, height: 40, marginRight: 10 }}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body1">
                      <strong>Destination Charges:</strong>
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: "right" }}>
                    <Typography variant="body1">
                      {formatrates(
                        viewBreakupData?.DestinationCharges?.toFixed(2)
                      )}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}

              {destinationPickup && viewBreakupData?.deliveryCharges > 0 && (
                <TableRow>
                  <TableCell>
                    <Typography variant="body1">
                      <img
                        src={delivery}
                        alt="Origin"
                        style={{ width: 40, height: 40, marginRight: 10 }}
                      />
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body1">
                      <strong>Delivery Charges:</strong>
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: "right" }}>
                    <Typography variant="body1">
                      {formatrates(viewBreakupData?.deliveryCharges)}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* 
  
  
  */}
      </AlertDialogBox>

      <AlertDialogBox
        open={open}
        type="cancelBooking"
        handleBack={() => navigate(-1)}
        handleClose={() => setOpen(0)}
      >
        <Box sx={{ padding: 2, width: "full" }}>
          <Typography variant="h5" sx={{ fontWeight: 600, padding: 1 }}>
            Book Shipment
          </Typography>
          {/* Origin/Destination Header */}
          <Paper
            sx={{
              padding: 2,
              mb: 2,
              backgroundColor: "#fff9eb",
              borderRadius: 2,
              border: "1px solid #f9e8c0",
              boxShadow: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "#f4be3d" }}
                >
                  {airportcode?.origincode}
                  {", "} {originPort?.origincountryName}
                  {"→"}
                  {airportcode?.destinationcode}
                  {", "}
                  {destinationPort?.destinationcountryName}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    fontSize: 14,
                    marginTop: 0.5,
                  }}
                >
                  Departure Date:{" "}
                  {moment(goodsDetails?.cargoreadydate).format(
                    "DD-MMM-YYYY hh:mm A"
                  )}{" "}
                  | Goods type: {comodity_des} | Total
                  shipment: {packagingDetails?.shipmentTotal?.totalunits} Units,
                  {""}
                  {Number(
                    packagingDetails?.shipmentTotal?.totalvolume
                  )?.toFixed(4)}{" "}
                  {packagingDetails?.shipmentTotal?.unit},{" "}
                  {packagingDetails?.shipmentTotal?.totalweight}
                  {packagingDetails?.shipmentTotal?.weightunit}
                </Typography>
              </Box>
            </Box>
          </Paper>

          {/* Flight Cards */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {/* {availabilityResponseSOs?.[
                indexTab
              ]?.availabilityResponseSOs?.map((option, index) => {
                const checkItinerary = option?.flightItineraries?.length > 1;
                const _item = option?.flightItineraries?.[0];
                const scheduledArrivalTime =
                  option?.flightItineraries?.[
                    option.flightItineraries.length - 1
                  ]?.scheduledArrivalTime;
                const isRowExpanded = expandedRows?.includes(index); */}

            {availabilityResponseSOs?.[indexTab]?.availabilityResponseSOs
              ?.filter(
                (option) => option?.requestRefId === selecteddata?.requestRefId
              )
              ?.map((option, index) => {
                const checkItinerary = option?.flightItineraries?.length > 1;
                const _item = option?.flightItineraries?.[0];
                const scheduledArrivalTime =
                  option?.flightItineraries?.[
                    option.flightItineraries.length - 1
                  ]?.scheduledArrivalTime;
                // console.log(expandedRows2, "expandedRows2");
                // You want each modal or item to toggle independently, even though the filtered array only has one item. use  stable and unique identifier like request ref id as index is alyas the same in case of filtered array case .

                const uniqueKey = option?.requestRefId;
                const isRowExpanded2 = expandedRows2.includes(uniqueKey);
                const checkAirline =
                  option?.flightItineraries?.[0]?.carrierCode === "020";
                const airline = option?.flightItineraries?.[0]?.carr_name;

                const serviceType =
                  option?.productCommodityDetails?.specialHandlingCodes?.includes(
                    "XPS"
                  )
                    ? `${_item.carrierCode} Plus`
                    : option?.productCommodityDetails?.specialHandlingCodes?.includes(
                      "VIC"
                    )
                      ? `${_item.carrierCode} Prime`
                      : `${_item.carrierCode} General`;
                // console.log(isRowExpanded, "isRowExpanded");

                return (
                  <Paper
                    key={index}
                    sx={{
                      backgroundColor: "#fff9eb",
                      borderRadius: 2,
                      border: "1px solid #f9e8c0",
                      borderRadius: 2,
                      overflow: "hidden",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    }}
                  >
                    {/* Main Card Content */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        flexDirection: "row",
                        p: 2,
                        alignItems: "center",
                      }}
                    >
                      {/* Airline Logo and Name */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          mr: 3,
                          minWidth: 100,
                        }}
                      >
                        <img
                          src={
                            option?.flightItineraries?.[0]?.carrierLogo ||
                            airlinelogo
                          }
                          alt={airline}
                          style={{
                            width: 50,
                            height: 50,
                            objectFit: "contain",
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 600,
                            color: "text.primary",
                            fontSize: "0.8rem",
                          }}
                        >
                          {airline}
                        </Typography>
                      </Box>

                      {/* Route and Timing */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <FlightIcon
                          sx={{
                            color: "primary.main",
                            transform: "rotate(90deg)",
                            mr: 1,
                          }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: "1rem",
                            fontWeight: 400,
                            color: "text.primary",
                          }}
                        >
                          {option?.origin} - {option?.destination}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: 500,
                          color: "#4A4A4A",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                        >
                          {moment(_item?.scheduledDepartureTime).format(
                            "DD MMM YYYY"
                          )}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                        >
                          {moment(_item?.scheduledDepartureTime).format(
                            "hh:mm A"
                          )}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          fontSize: "0.9rem",
                          fontWeight: 600,
                          color: "text.primary",
                        }}
                      >
                        - {option.travelTime} -
                      </Box>

                      <Box
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: 600,
                          color: "#4A4A4A",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                        >
                          {moment(scheduledArrivalTime).format("DD MMM YYYY")}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                        >
                          {moment(scheduledArrivalTime).format("hh:mm A")}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          flexWrap: "wrap",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 600, fontSize: "1rem" }}
                        >
                          {formatrates(option?.rateDetails?.totalAmount)}
                        </Typography>
                        <Button
                          variant="text"
                          size="small"
                          onClick={() => checkViewBreakuUp(option)}
                          sx={{
                            color: "#4A4A4A",
                            fontSize: "0.6rem",
                            display: "flex",
                          }}
                        >
                          View Breakup
                          <KeyboardArrowDown />
                        </Button>
                      </Box>
                    </Box>

                    <hr className="border-gray-300 border-3 my-3" />

                    <Box
                      sx={{ flex: 1, paddingleft: 1, margin: 0, minWidth: 0 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            marginLeft: 1,
                            fontSize: "0.8rem",
                            fontWeight: 400,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={aeroplan}
                            className="w-2 h-2 p-1 bg-yellow-300 rounded-full"
                            alt="Service Type"
                          />
                          <span className="ml-2">Service: {serviceType}</span>
                        </Typography>
                        {/* {console.log(index, "index23")} */}
                        <IconButton
                          size="small"
                          onClick={() => toggleRow2(uniqueKey)}
                          sx={{ ml: "auto", marginRight: 1 }}
                        >
                          {isRowExpanded2 ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>
                      </Box>
                    </Box>

                    {/* Expanded Flight Details */}
                    <Collapse in={isRowExpanded2} timeout="auto" unmountOnExit>
                      <Box
                        sx={{
                          p: 2,
                          backgroundColor: "white",
                          borderTop: "1px solid",
                          borderColor: "divider",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          {option?.flightItineraries?.map((detail, idx) => (
                            <Box>
                              <Paper key={idx}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                    flexDirection: "row",
                                    // p: 2,
                                    alignItems: "center",
                                  }}
                                >
                                  {/* Airline Name & Logo */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      minWidth: 180,
                                    }}
                                  >
                                    <img
                                      src={detail?.carrierLogo || airlinelogo}
                                      width={40}
                                      height={40}
                                      alt="Airline"
                                    />
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: "bold",
                                        fontSize: "0.6rem",
                                      }}
                                    >
                                      {detail?.carr_name}
                                    </Typography>
                                  </Box>

                                  {/* Route & Timing */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      gap: 1,
                                    }}
                                  >
                                    <FlightIcon
                                      sx={{
                                        color: "primary.main",
                                        transform: "rotate(90deg)",
                                        mx: 1,
                                      }}
                                    />
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: "semi-bold",
                                        fontSize: "0.6rem",
                                      }}
                                    >
                                      {detail?.segmentOfDeparture} to{" "}
                                      {detail?.segmentOfArrival}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      gap: 1,
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: "0.6rem",
                                        fontWeight: 200,
                                      }}
                                    >
                                      {moment(
                                        detail?.scheduledDepartureTime
                                      ).format("DD MMM YYYY")}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: "0.6rem",
                                        fontWeight: 200,
                                      }}
                                    >
                                      {moment(
                                        detail?.scheduledDepartureTime
                                      ).format("hh:mm A")}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      gap: 1,
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: "semibold",
                                        fontSize: "0.7rem",
                                      }}
                                    >
                                      -
                                      {/* {convertMinutesToHoursAndMinutes(
                                      moment(detail.scheduledArrivalTime).diff(
                                        moment(detail.scheduledDepartureTime),
                                        "minutes"
                                      )
                                    )} */}
                                      {detail?.travelTime}-
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      gap: 1,
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: "0.7rem",
                                        fontWeight: 200,
                                      }}
                                    >
                                      {moment(
                                        detail?.scheduledArrivalTime
                                      ).format("DD MMM YYYY")}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: "0.7rem",
                                        fontWeight: 200,
                                      }}
                                    >
                                      {moment(
                                        detail?.scheduledArrivalTime
                                      ).format("hh:mm A")}
                                    </Typography>
                                  </Box>

                                  {/* Aircraft */}
                                  <Box sx={{ minWidth: 80 }}>
                                    <Typography
                                      variant="body2"
                                      fontWeight={300}
                                    >
                                      Aircraft
                                    </Typography>
                                    <Typography variant="body2">
                                      {detail.carrierAircraftType}
                                    </Typography>
                                  </Box>

                                  {/* Flight # */}
                                  <Box sx={{ minWidth: 80 }}>
                                    <Typography
                                      variant="body2"
                                      fontWeight={300}
                                    >
                                      Flight #
                                    </Typography>
                                    <Typography variant="body2">
                                      {/* {detail.carrierCode} */}
                                      {detail.carrierNumber}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Paper>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </Collapse>
                  </Paper>
                );
              })}
          </Box>
        </Box>
        <Box>
          {/* <BookCargo nodeData={nodeData} item={item}/> */}
          <BookCargo
            // nodeData={searchratesAvailableData?.nodeData}
            // nodeData={updatedNodeData}
            // props={JSON.parse(JSON.stringify(props.nodeData))}
            setSelecteddata={setSelecteddata}
            setOpenbooking={setOpenbooking}
            selecteddata={selecteddata}
            open={open}
            setOpen1={setOpen}
            // queryidall={queryidall}
            handleClose={() => setOpen(0)} // Pass handleClose
          />
        </Box>
      </AlertDialogBox>
      <AlertDialogBox
        open={openbooking && requestType === "2"}
        // type="cancelBooking"
        // textMessage="Book Shipment"
        handleBack={() => navigate(-1)}
        handleClose={() => setOpen(0)}
      >
        <Bookingintermediatrypage
          isOpen={openbooking && requestType === "2"}
          // props={JSON.parse(JSON.stringify(props.nodeData))}
          onClose={() => navigate("/search-rates")} //setBookingType("")&& setIsModalOpen(false)&& setOpen1(false)
          selectedItem={selecteddata}
          title="Booking Confirmation"
          // nodeData1={updatedNodeData}
          onConfirm={() => navigate("/booking-history")}
        />
      </AlertDialogBox>
    </>
  );
};

export default React.memo(NewRateAvailableList);

